import Cookies from "universal-cookie";


export const clearCookies = () => {
    const cookies = new Cookies();
    cookies.remove("access_token", { path: "/" });
    cookies.remove("hr_access_token", { path: "/" });
    cookies.remove("token_expired", { path: "/" });
}